import React from "react";
import { Span } from "../../../../../Span";
import { Flex } from "../../../../../Flex";
import { ReviewFormContactDetails } from "../../../../../ReviewFormContactDetails";
import { DisconnectionContactDetails } from "../../../../../../types/DisconnectionContactDetails";
import {
  mapPropertyOwnerHeader,
  mapRequestHeader,
  mapSiteContactHeader,
} from "../../../DisconnectionFormUtils/DisconnectionFormUtils";
import { Box } from "../../../../../Box";

interface Props {
  id: string;
  disconnectionContactDetails: DisconnectionContactDetails;
}

export const ReviewFormDisconnectionContactDetails: React.FC<Props> = ({
  id,
  disconnectionContactDetails,
}) => {
  return (
    <Flex id={id} flexDirection="column">
      <Span lineHeight={2} fontWeight="bold" mb={3}>
        {mapRequestHeader(disconnectionContactDetails)}
      </Span>

      <Box id={`${id}-requester`}>
        <ReviewFormContactDetails
          contactDetails={disconnectionContactDetails.requester}
        />
      </Box>

      {disconnectionContactDetails.propertyOwnerSameAsRole ===
        "new-contact" && (
        <>
          <Span lineHeight={2} fontWeight="bold" mb={3}>
            {mapPropertyOwnerHeader(disconnectionContactDetails)}
          </Span>

          <Box id={`${id}-property-owner`}>
            <ReviewFormContactDetails
              contactDetails={disconnectionContactDetails.propertyOwner}
            />
          </Box>
        </>
      )}

      {disconnectionContactDetails.siteContactSameAsRole === "new-contact" && (
        <>
          <Span lineHeight={2} fontWeight="bold" mb={3}>
            {mapSiteContactHeader(disconnectionContactDetails)}
          </Span>

          <Box id={`${id}-site-contact`}>
            <ReviewFormContactDetails
              contactDetails={disconnectionContactDetails.siteContact}
            />
          </Box>
        </>
      )}
    </Flex>
  );
};
